<template>
  <v-alert v-if="next_day_report" top type="error" prominent>
    <v-row align="center">
      <v-col class="grow">
        Je hebt een geplande {{ next_day_report.day_report_type }} dienst op
        {{ next_day_report.date }}
      </v-col>
      <v-col class="shrink">
        <v-btn @click="openDayReport"> Open dagrapport </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { useDayReportsStoreRefactor } from "@/stores/dayReportsStoreRefactor";

export default {
  name: "DayReportOpenPlanned",
  props: ["next_day_report"],
  setup(props) {
    const dayReportsStore = useDayReportsStoreRefactor();

    async function openDayReport() {
      await dayReportsStore.open(props.next_day_report);
    }

    return {
      openDayReport,
    };
  },
};
</script>
